import styles from "./progressiveBar.module.scss";

function ProgressiveBar(props: any) {
  const { total, current, className = "" } = props;
  let widthPercent = 0;
  if (total === 0) {
    widthPercent = 100;
  } else { widthPercent = (current * 100) / total; }
  return (
    <div className={styles.progressive_bar_container}>
      <div style={{ width: `${widthPercent}%` }} className={`${styles.progressive_bar} ${className} `} />
    </div>
  );
}

export default ProgressiveBar;
